import { IData } from '@hooks/useData';
import { useModalWindow } from '@hooks/useModalWindow';
import { IComboEmpresa } from '@model/Empresa';
import { IVendedor } from '@model/Vendedor';
import { IVendedorComissaoFilter, IVendedorComissaoRecord } from '@services/VendedorComissaoService';
import React from 'react';
import { ComissaoCreditoModal } from './ComissaoCreditoModal';
import { ComissaoDebitoModal } from './ComissaoDebitoModal';
import { ComissaoPagamentoModal } from './ComissaoPagamentoModal';
import { VendedorComissaoFilter } from './Filter';
import { FichaVendedorComissaoTable } from './Table';

export type FichaVendedorComissaoProps = {
    data: IData<IVendedorComissaoRecord, IVendedorComissaoFilter>
    isLoading: boolean
    vendedor: IVendedor
    comboEmpresa: IComboEmpresa
}

export function FichaVendedorComissao ({ data, isLoading, vendedor, comboEmpresa }: FichaVendedorComissaoProps) {
    const creditoModal = useModalWindow();
    const debitoModal = useModalWindow();
    const pagamentoModal = useModalWindow();
    
    return (
        <React.Fragment>
            <VendedorComissaoFilter 
                filter={data.filter}
                isLoading={isLoading}
                creditoModal={creditoModal}
                debitoModal={debitoModal}
                pagamentoModal={pagamentoModal}
            />

            <FichaVendedorComissaoTable 
                isLoading={isLoading}
                data={data}
            />

            <ComissaoCreditoModal 
                modal={creditoModal}
                vendedor={vendedor}
                onComissaoRegistrada={data.filter.handleFilterRequest}
            />

            <ComissaoDebitoModal 
                modal={debitoModal}
                vendedor={vendedor}
                onComissaoRegistrada={data.filter.handleFilterRequest}
            />

            <ComissaoPagamentoModal
                modal={pagamentoModal}
                vendedor={vendedor}
                onComissaoRegistrada={data.filter.handleFilterRequest}
                comboEmpresa={comboEmpresa}
            />
        </React.Fragment>
    )
}